import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';
import '../styles/resume.css';

const resumes = [
  {
    name: "Professional Resume",
    file: "/Merit Edafe CV.pdf",
    downloadName: "Merit_Edafe_CV.pdf",
  },
  {
    name: "HNG Resume",
    file: "/Merit Edafe HNG experience.pdf",
    downloadName: "Merit_Edafe_HNG_Resume.pdf",
  },
];

const Resume = () => {
  const [numPages, setNumPages] = useState(null);
  const [currentResume, setCurrentResume] = useState(null);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const openResume = (resume) => {
    setCurrentResume(resume);
  };

  const closeResume = () => {
    setCurrentResume(null);
  };

  return (
    <div className="Resume-container">
      {/* Buttons to Download / View */}
      <div className="Resume-options">
        {resumes.map((resume, index) => (
          <div key={index} className="resume-buttons">
            <button onClick={() => openResume(resume)} className="view-button">
              View {resume.name}
            </button>
            <a 
              href={resume.file} 
              download={resume.downloadName} 
              className="download-button"
            >
              Download {resume.name}
            </a>
          </div>
        ))}
      </div>

      {/* PDF Viewer Modal */}
      {currentResume && (
        <div className="Resume-viewer-overlay">
          <button className="close-button" onClick={closeResume}>✕</button>
          <div className="Resume-viewer">
            <Document
              file={currentResume.file}
              onLoadSuccess={onDocumentLoadSuccess}
            >
              {Array.from(new Array(numPages), (el, index) => (
                <div
                  key={`page-wrapper-${index + 1}`}
                  className={`Resume-page-wrapper ${index === 0 ? 'first-page' : ''}`}
                >
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    width={window.innerWidth < 768 ? window.innerWidth - 40 : 600}
                    className="Resume-page"
                  />
                </div>
              ))}
            </Document>
          </div>
        </div>
      )}
    </div>
  );
};

export default Resume;
